import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const handleEmailClick = (email) => (e) => {
    // Eğer mailto çalışmazsa alternatif çözüm
    const mailtoLink = `mailto:${email}`;

    // Önce mailto'yu dene
    try {
      window.location.href = mailtoLink;
    } catch (error) {
      // Eğer mailto çalışmazsa, e-posta adresini panoya kopyala
      navigator.clipboard
        .writeText(email)
        .then(() => {
          alert(`E-posta adresi panoya kopyalandı: ${email}`);
        })
        .catch(() => {
          alert(`E-posta adresi: ${email}`);
        });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src="/images/logo.png"
                alt="RPM Kompresör Logo"
                className="logo-image"
              />
            </div>
            <p className="footer-description">
              Endüstriyel kompresör çözümlerinde güvenilir ortağınız. Kaliteli
              ürünler ve profesyonel hizmet anlayışımızla sektörde öncüyüz.
            </p>
            <div className="footer-map">
              <iframe
                src="https://maps.google.com/maps?q=39.985982,32.730943&hl=tr&z=16&output=embed"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="RPM Kompresör Konumu - ERC İş Merkezi, İvedik OSB, 1443. Sk. No:20/B, 06480 Yenimahalle/Ankara"
              ></iframe>
            </div>
            <div className="dealer-badge">
              <img
                src="/images/aydin_trafo_logo.jpg"
                alt="Aydın Trafo Logo"
                className="dealer-logo"
              />
              <span className="dealer-text">
                Aydın Trafo Yetkili Bayisidir.
              </span>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Hızlı Linkler</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Ana Sayfa</Link>
              </li>
              <li>
                <Link to="/hizmetler">Hizmetler</Link>
              </li>
              <li>
                <Link to="/urunler">Ürünler</Link>
              </li>
              <li>
                <Link to="/hakkimizda">Hakkımızda</Link>
              </li>
              <li>
                <Link to="/kurumsal">Kurumsal</Link>
              </li>
              <li>
                <Link to="/iletisim">İletişim</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">İletişim</h3>
            <div className="contact-info">
              <div className="contact-item">
                <strong>Adres:</strong>
                <p>
                  ERC iş merkezi, İvedik OSB, 1443. Sk. No:20/B
                  <br />
                  06480 Yenimahalle/Ankara
                </p>
              </div>
              <div className="contact-item">
                <strong>Telefon:</strong>
                <p>
                  <a href="tel:+905342137564" className="phone-link">
                    +90 0534 213 75 64
                  </a>
                </p>
              </div>
              <div className="contact-item">
                <strong>E-posta:</strong>
                <p>
                  <a
                    href="mailto:info@rpmendustri.com"
                    className="email-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleEmailClick("info@rpmendustri.com")}
                  >
                    info@rpmendustri.com
                  </a>
                </p>
                <p>
                  <a
                    href="mailto:satis@rpmendustri.com"
                    className="email-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleEmailClick("satis@rpmendustri.com")}
                  >
                    satis@rpmendustri.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Çalışma Saatleri</h3>
            <div className="working-hours">
              <p>Pazartesi - Cumartesi: 08:00 - 17:30</p>
              <p>7/24 Destek</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 RPM Kompresör. Tüm hakları saklıdır.</p>
          <div className="social-links">
            <a
              href="https://wa.me/905342137564"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
